<template>
  <div>
    <!-- Campo de búsqueda -->
    <div class="columns is-multiline">
      <b-field class="column is-12" label="Buscar">
        <b-input
          v-model="searchQuery"
          placeholder="Buscar..."
          type="search"
          icon-right-clickable
          expanded
          @icon-right-click="searchQuery = ''"
          @input="reloadSearch"
          @keydown.native.enter="loadAsyncData"
        >
        </b-input>

        <b-button @click="loadAsyncData" type="is-primary" class="ml-2"> Buscar </b-button>
      </b-field>
      <b-field class="column is-4" label="Círculo">
        <b-select v-model="circleFilter" expanded @input="loadAsyncData">
          <option value="">Todos los círculos</option>
          <option v-for="circle in circlesOptions" :key="circle.id" :value="String(circle.id)">{{ circle.nombre }}</option>
        </b-select>
      </b-field>
      <b-field class="column is-4" label="Subespecialidad">
      <b-select v-model="subspecialtyFilter" expanded @input="loadAsyncData">
        <option value="">Todas las subespecialidades</option>
        <option value="none">Sin subespecialidad</option>
        <option v-for="item in subspecialtiesOptions" :key="item.id" :value="String(item.id)">{{ item.nombre }}</option>
        </b-select>
      </b-field>
      <b-field class="column is-4" label="Estado">
        <b-select v-model="statusFilter" expanded @input="loadAsyncData">
          <option value="activos">Activos</option>
          <option value="inactivos">Inactivos</option>
          <option value="todos">Todos</option>
        </b-select>
      </b-field>
    </div>

    <!-- Tabla -->
    <b-table
      :data="data"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :loading="loading"
      :per-page="perPage"
      :total="total"
      :checked-rows.sync="selected"
      checkable
      backend-pagination
      backend-sorting
      paginated
      @page-change="onPageChange"
      @sort="onSort"
      filters-change
      striped
    >
      <b-table-column field="id" label="#" sortable v-slot="props">
        {{ props.row.id }}
      </b-table-column>
      <b-table-column field="nombre" label="Datos del socio" sortable v-slot="props">
        <div>{{ props.row.nombre }} {{ props.row.apellido }}</div>
        <div class="has-text-grey is-size-7">{{ props.row.empresa }}</div>
        <div class="has-text-grey is-size-7">{{ props.row.email }}</div>
        <div class="has-text-grey is-size-7">RFC: {{ props.row.rfc }}</div>
      </b-table-column>
      <b-table-column field="circulo_nombre" label="Círculo" sortable v-slot="props">
        {{ props.row.circulo_nombre || 'Sin círculo' }}
      </b-table-column>
      <b-table-column field="categoria_nombre" label="Categoría" sortable v-slot="props">
        {{ props.row.categoria_nombre || 'Sin categoría' }}
      </b-table-column>
      <b-table-column field="subespecialidad_nombre" label="Subespecialidad" sortable v-slot="props">
        {{ props.row.subespecialidad_nombre || 'Sin subespecialidad' }}
      </b-table-column>
      <b-table-column field="rfc" label="Vigencia" sortable v-slot="props" width="120">
        {{ props.row.vigencia }}
      </b-table-column>
      <b-table-column field="acciones" label="Acciones" v-slot="props" width="80">
        <div class="buttons">
          <b-button @click="openModal(props.row)" type="is-primary" icon-left="eye" size="is-small" title="Ver"></b-button>
          <b-button @click="deleteRow(props.row.id)" type="is-danger" icon-left="delete" size="is-small" title="Eliminar"></b-button>
        </div>
      </b-table-column>
    </b-table>

    <b-modal v-model="bulkModal" has-modal-card trap-focus>
      <div class="modal-card">
        <header class="modal-card-head"><p class="modal-card-title">Asignar subespecialidad</p></header>
        <section class="modal-card-body">
          <p class="mb-4">Se actualizarán {{ selected.length }} socios.</p>
          <b-field label="Categoría">
            <b-select v-model="bulkCategoryId" expanded @input="loadBulkSubspecialties">
              <option :value="null">Selecciona una categoría</option>
              <option v-for="category in categoriesOptions" :key="category.id" :value="Number(category.id)">{{ category.nombre }}</option>
            </b-select>
          </b-field>
          <b-field label="Subespecialidad">
            <b-select v-model="bulkSubspecialtyId" expanded :disabled="!bulkCategoryId || loadingBulkSubspecialties">
              <option :value="null">Selecciona una subespecialidad</option>
              <option v-for="item in bulkSubspecialtiesOptions" :key="item.id" :value="Number(item.id)">{{ item.nombre }}</option>
            </b-select>
          </b-field>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <b-button @click="bulkModal = false">Cancelar</b-button>
          <b-button type="is-primary" :loading="bulkSaving" :disabled="!bulkSubspecialtyId" @click="assignBulk">Asignar</b-button>
        </footer>
      </div>
    </b-modal>

    <div class="modal form-guests-modal" :class="{ 'is-active': showFormModal }">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <h2 class="modal-card-title">Editar socio</h2>
          <button @click="closeForm()" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <Form :key="formKey" :datavalues="formModalData" @close-form="closeForm"></Form>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end"></footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Form from './form.vue';
import Swal from 'sweetalert2';
import axiosInstance from '@/api/axiosInstance';

export default {
  components: {
    Form,
  },
  data() {
    return {
      formKey: 0,
      data: [],
      total: 0,
      loading: false,
      sortField: 'id',
      sortOrder: 'desc',
      defaultSortOrder: 'desc',
      page: 1,
      perPage: 20,
      searchQuery: '',
      showFormModal: false,
      formModalData: {},
      circleFilter: '',
      subspecialtyFilter: '',
      statusFilter: 'activos',
      circlesOptions: [],
      subspecialtiesOptions: [],
      categoriesOptions: [],
      bulkSubspecialtiesOptions: [],
      bulkCategoryId: null,
      loadingBulkSubspecialties: false,
      selected: [],
      bulkModal: false,
      bulkSubspecialtyId: null,
      bulkSaving: false,
    };
  },
  async mounted() {
    window.scrollTo(0, 0);
    await this.loadFilters();
    await this.loadAsyncData();
  },
  computed: {
    ...mapState({
      associates: (state) => state.associates.list,
      pagination: (state) => state.associates.pagination,
      reload: (state) => state.associates.reloadList,
    }),
  },
  watch: {
    selected: {
      deep: true,
      handler(value) {
        this.$emit('selection-change', value.length);
      },
    },
    async reload(newValue) {
      if (newValue) {
        await this.loadAsyncData();
      }
    },
  },
  methods: {
    ...mapActions({
      fetchList: 'associates/fetchList',
      remove: 'associates/remove',
    }),
    async loadAsyncData() {
      this.loading = true;

      const params = {
        page: this.page,
        size: this.perPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        search: this.searchQuery.toLowerCase(),
        circulo_id: this.circleFilter,
        subespecialidad_id: this.subspecialtyFilter,
        estado: this.statusFilter,
      };

      await this.fetchList(params);

      this.data = this.associates;
      this.selected = [];
      this.total = this.pagination.total;

      this.loading = false;
      this.$store.commit('associates/SET_DATA', { key: 'reloadList', data: false });
    },
    async loadFilters() {
      const [circlesResponse, subspecialtiesResponse, categoriesResponse] = await Promise.all([
        axiosInstance.get('/circles/list?size=1000&page=1'),
        axiosInstance.get('/catalogs/subspecialties_options'),
        axiosInstance.get('/catalogs/categories_options'),
      ]);
      this.circlesOptions = circlesResponse?.data?.data?.circles?.list || [];
      this.subspecialtiesOptions = subspecialtiesResponse?.data?.data?.subspecialties || [];
      this.categoriesOptions = categoriesResponse?.data?.data?.categories || [];
    },
    async assignBulk() {
      this.bulkSaving = true;
      try {
        const response = await axiosInstance.post('/associates/bulk_subspecialty', {
          ids: this.selected.map((row) => row.id),
          subespecialidad_id: this.bulkSubspecialtyId,
        });
        await Swal.fire({ icon: response.data.status ? 'success' : 'error', title: response.data.message });
        if (response.data.status) {
          this.bulkModal = false;
          this.bulkSubspecialtyId = null;
          this.bulkCategoryId = null;
          this.bulkSubspecialtiesOptions = [];
          await this.loadAsyncData();
        }
      } finally {
        this.bulkSaving = false;
      }
    },
    openBulkModal() {
      if (this.selected.length) this.bulkModal = true;
    },
    async loadBulkSubspecialties() {
      this.bulkSubspecialtyId = null;
      this.bulkSubspecialtiesOptions = [];
      if (!this.bulkCategoryId) return;
      this.loadingBulkSubspecialties = true;
      try {
        const response = await axiosInstance.get('/catalogs/subspecialties_options', { params: { categoria_id: this.bulkCategoryId } });
        this.bulkSubspecialtiesOptions = response?.data?.data?.subspecialties || [];
      } finally {
        this.loadingBulkSubspecialties = false;
      }
    },
    async onPageChange(page) {
      this.page = page;
      await this.loadAsyncData();
    },
    async onSort(field, order) {
      this.sortField = field;
      this.sortOrder = order;
      await this.loadAsyncData();
    },
    async reloadSearch() {
      if (this.searchQuery.length == 0) {
        await this.loadAsyncData();
      }
    },
    openModal(data) {
      this.formKey++;
      this.showFormModal = true;
      this.formModalData = data;
    },
    closeForm() {
      this.showFormModal = false;
    },
    async deleteRow(id) {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'No podrás recuperar este registro después de eliminarlo.',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, borrar',
        cancelButtonText: 'Cancelar',
      });

      if (result.isConfirmed) {
        const response = await this.remove(id);

        Swal.fire({
          icon: response.status ? 'success' : 'error',
          title: response.message,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: true,
        });

        await this.loadAsyncData();
      }
    },
  },
};
</script>

<style>
.b-table .table-wrapper {
  overflow: auto;
}
</style>
